import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

export const SettingsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction='ListSettings' redirectTo='/'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            >

                <Route
                    path=':tab'
                    element={
                        <AuthorizedRouteElement rbacAction='ListSettings' redirectTo='/'>
                            <IndexPage/>
                        </AuthorizedRouteElement>
                    }
                />

            </Route>

        </Routes>
    );
};
